import React from 'react'
import { PageLoading } from 'components/Loading'

export const AuthPageLoading = () => <PageLoading style={{ minHeight: 400, margin: 'auto' }} />
